// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MenuToggleController from "./menu_toggle_controller"
application.register("menu-toggle", MenuToggleController)

import PromptFitController from "./prompt_fit_controller"
application.register("prompt-fit", PromptFitController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SignSwapController from "./sign_swap_controller"
application.register("sign-swap", SignSwapController)

import SubmissionModalController from "./submission_modal_controller"
application.register("submission-modal", SubmissionModalController)
